"use client";

import { track } from "@opensea/analytics";
import { CenterAligned, classNames } from "@opensea/ui-kit";
import { useEventListener, useScrollLock } from "@opensea/ui-kit/hooks";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { EXPANDED_SEARCH_SELECTOR, ExpandedSearchMenu } from "@/components/expanded-search/ExpandedSearchMenu";
import { withSuspense } from "../suspense/WithSuspense";
import { expandedSearchTransitionClassNames } from "./constants";
import { useExpandedSearchStore } from "./ExpandedSearchStore";
export const ExpandedSearch = withSuspense(function ExpandedSearch() {
  const [open, setOpen, selectedCategory, searchQuery, setSearchQuery] = useExpandedSearchStore(useShallow(state => [state.open, state.setOpen, state.selectedCategory, state.searchQuery, state.setSearchQuery]));
  const handleDismiss = source => {
    void track("Search Dismissed", {
      query: searchQuery,
      query_length: searchQuery.length,
      category: selectedCategory,
      has_query: searchQuery.length > 0,
      dismiss_source: source
    });
    setOpen(false);
    setSearchQuery("");
  };
  useEventListener("keydown", event => {
    switch (event.key) {
      case "k":
        if (!open && event.metaKey) {
          event.preventDefault();
          setOpen(true);
        }
        break;
      case "/":
        {
          const tagName = event.target?.tagName;
          const isInputFocused = tagName === "INPUT" || tagName === "TEXTAREA";
          if (!(open || isInputFocused)) {
            event.preventDefault();
            setOpen(true);
          }
          break;
        }
      case "Escape":
        if (open) {
          event.preventDefault();
          handleDismiss("escape_key");
        }
        break;
    }
  });
  const {
    lock,
    unlock
  } = useScrollLock({
    autoLock: false
  });
  useEffect(() => {
    if (open) {
      lock();
    } else {
      unlock();
    }
  }, [open]);
  return <CenterAligned className={classNames("fixed inset-0 z-expanded-search size-full", expandedSearchTransitionClassNames, open ? "pointer-events-auto bg-overlay" : "pointer-events-none")}>
      <div className="fixed inset-0 size-full" onClick={() => {
      handleDismiss("outside_click");
    }} />
      <CenterAligned className="z-1 size-full lg:w-auto" onClick={e => {
      // Close if we're clicking on the overlay
      if (!e.target.closest(`#${EXPANDED_SEARCH_SELECTOR}`)) {
        handleDismiss("outside_click");
      }
    }}>
        <ExpandedSearchMenu />
      </CenterAligned>
    </CenterAligned>;
});